import React from 'react'
import { Logos } from '@app/src/wf-constants'

const WorldfavorLogo: React.FC = () => (
  <img src={Logos.WorldfavorLogoSquareFilledBlack} alt="Worldfavor" style={{ height: 32 }} />
)

export default WorldfavorLogo
